// Coordenadas de referencia de las zonas de cobertura (lista fija de
// ProviderAssets/PostAsset). El pin es a nivel de zona: la dirección exacta
// de entrega se coordina con el proveedor. Sin geocoding externo.
export const ZONE_COORDS = {
  'Punta Cana':    { lat: 18.582,  lng: -68.4055, zoom: 12 },
  'Bávaro':        { lat: 18.677,  lng: -68.412,  zoom: 12 },
  'Cap Cana':      { lat: 18.4899, lng: -68.4046, zoom: 13 },
  'Santo Domingo': { lat: 18.4861, lng: -69.9312, zoom: 12 },
  'La Romana':     { lat: 18.4273, lng: -68.9728, zoom: 12 },
  'Bayahíbe':      { lat: 18.3714, lng: -68.8382, zoom: 13 },
  'Puerto Plata':  { lat: 19.7934, lng: -70.6884, zoom: 12 },
  'Cabarete':      { lat: 19.7494, lng: -70.4082, zoom: 13 },
  'Sosúa':         { lat: 19.7522, lng: -70.5147, zoom: 13 },
  'Samaná':        { lat: 19.2057, lng: -69.3362, zoom: 12 },
  'Las Terrenas':  { lat: 19.311,  lng: -69.5427, zoom: 13 },
  'Las Galeras':   { lat: 19.2273, lng: -69.2313, zoom: 13 },
  'Jarabacoa':     { lat: 19.117,  lng: -70.6366, zoom: 13 },
  'Santiago':      { lat: 19.4517, lng: -70.6971, zoom: 12 },
};

// Lista única de zonas de cobertura. Todos los archivos (Homepage,
// SearchResults, ProviderAssets, PostAsset, etc.) deben importar ZONES
// desde aquí para evitar divergencia entre el catálogo público, la
// búsqueda y los formularios del proveedor.
export const ZONES = Object.keys(ZONE_COORDS);

// URL de direcciones de Google Maps (app o web según el dispositivo).
// No requiere API key: es un enlace público de intención de navegación.
export function directionsUrl(address, zone) {
  const dest = [address, zone, 'República Dominicana'].filter(Boolean).join(', ');
  return `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(dest)}`;
}
